// src/context/AuthContext.jsx
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [user, setUser] = useState(null); // Optional: Store user details if needed

  // Save token to localStorage when it changes
  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }, [token]);

  // Function to log in
  const login = (newToken) => {
    setToken(newToken);
  };

  // Function to log out
  const logout = () => {
    setToken(null); // Clear token from state
    setUser(null); // Clear user details
    localStorage.removeItem('token'); // Clear token from localStorage
    window.location.href = '/'; // Force a full page reload to reset the app state
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};